import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { type Types, getApplicationLabels } from 'modules/app_store/lib/getApplicationLabels'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

import AtsInstallModal from './AtsInstallModal/AtsInstallModal'

interface Props {
  subscriptionAddon: SubscriptionAddon
  onSubmit: () => void
  onClose: () => void
}

const DependencyInstallModal = ({ subscriptionAddon, onSubmit, onClose }: Props) => {
  const id = subscriptionAddon.attributes.id

  if (id === 'ats') return <AtsInstallModal onSubmit={onSubmit} onClose={onClose} />

  const { title, description } = getApplicationLabels(subscriptionAddon.type as Types, id)

  return (
    <Modal
      illustration="monitor-flash"
      title={title}
      description={description}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onSubmit}>{i18n.t('app_store_v2.common.install_apps')}</Button>
        </>
      }
    />
  )
}

export default DependencyInstallModal
